export const pollingUntil = <T>(requestFn: () => Promise<T>, conditionFn: (data: T) => boolean | Error, options: { interval?: number; timeout?: number } = {}) => {
  const { interval = 1000, timeout = 30000 } = options
  let timer: number | undefined
  let timeoutTimer: number | undefined
  let isActive = true // 控制轮询是否继续

  // 清理函数
  const cleanup = () => {
    isActive = false
    clearTimeout(timer)
    clearTimeout(timeoutTimer)
  }

  // 返回 Promise + 清理函数
  const promise = new Promise<T>((resolve, reject) => {
    // 超时处理
    timeoutTimer = window.setTimeout(() => {
      cleanup()
      reject({ code: 'TIMEOUT', message: 'time out' })
    }, timeout)

    // 轮询逻辑（递归调用）
    const poll = async () => {
      if (!isActive) return // 如果已终止，不再执行

      const startTime = Date.now()
      try {
        const data = await requestFn()
        const result = conditionFn(data)
        //
        if (typeof result !== 'boolean') {
          cleanup()
          reject(result)
          return
        }
        if (result) {
          cleanup()
          resolve(data)
          return
        }
      } catch (err) {
        cleanup()
        reject(err)
        return
      }

      // 动态计算下一次轮询时间
      const elapsed = Date.now() - startTime
      const nextDelay = Math.max(0, interval - elapsed)
      timer = window.setTimeout(poll, nextDelay)
    }

    // 开始轮询
    poll()
  })

  return { promise, cleanup }
}
